import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { FaCheckCircle, FaEdit, FaTrash, FaTimesCircle } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import "./Contracts.css"; // Asegúrate de tener este archivo CSS para los estilos

const Contracts = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [noContrato, setNoContrato] = useState(0);
  const stateContract = "ACTIVO";
  const [ruta, setRuta] = useState("");
  const [tipoCliente, setTipoCliente] = useState("");
  const [tipoEstablecimiento, setTipoEstablecimiento] = useState("");
  const [nombreEstablecimiento, setNombreEstablecimiento] = useState("");
  const [representanteLegal, setRepresentanteLegal] = useState("");
  const [nit, setNit] = useState("");
  const [barrio, setBarrio] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [plan, setPlan] = useState("");
  const [recoleccion, setRecoleccion] = useState("");
  const [valor, setValor] = useState("");
  const [insumos, setInsumos] = useState("");
  const [kilos, setKilos] = useState("");

  const currentDate = format(new Date().toISOString(), "yyyy-MM-dd");

  const [listContracts, setListContracts] = useState([]);
  const [listContractsFiltered, setListContractsFiltered] = useState([]);
  const [filterField, setFilterField] = useState("no_contrato");
  const [searchTerm, setSearchTerm] = useState("");

  const [listPlans, setListPlans] = useState([]);

  const [editingContract, setEditingContract] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [emptyData, setEmptyData] = useState(false);

  const typeMessages = {
    create: "¡Contrato registrado exitosamente!",
    update: "¡Datos del contrato actualizados exitosamente!",
    delete: "¡Contrato eliminado exitosamente!",
    error: "Error en el mensaje del modal",
  };

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getContracts();
    getPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentRecords, setCurrentRecords] = useState([]);
  const recordsPerPage = 20; // Puedes cambiarlo según necesidad

  // Calcular registros de la página actual
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  // Calcular total de páginas
  const totalPages = Math.ceil(listContractsFiltered.length / recordsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
      setCurrentPage(1); // Resetear a la primera página al filtrar
    }, [listContractsFiltered]);

  useEffect(() => {
      setCurrentRecords([]);
      setTimeout(() => {
        setCurrentRecords(
          listContractsFiltered.slice(indexOfFirstRecord, indexOfLastRecord)
        );
      }, 500);
    }, [
      listContractsFiltered,
      currentPage,
      indexOfFirstRecord,
      indexOfLastRecord,
    ]);

  const openModalSuccess = (type) => {
    switch (type) {
      case "create":
        setMessageModal(typeMessages.create);
        break;
      case "update":
        setMessageModal(typeMessages.update);
        break;
      case "delete":
        setMessageModal(typeMessages.delete);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const getNextContractNumber = (contracts) => {
    if (contracts.length > 0) {
      const sortedContracts = [...contracts].sort(
        (a, b) => a.no_contrato - b.no_contrato
      );
      setNoContrato(
        sortedContracts[sortedContracts.length - 1].no_contrato + 1
      );
    }
  };

  const cleanFormContracts = () => {
    setRuta("");
    setTipoCliente("");
    setTipoEstablecimiento("");
    setNombreEstablecimiento("");
    setRepresentanteLegal("");
    setNit("");
    setBarrio("");
    setDireccion("");
    setTelefono("");
    setCorreo("");
    setPlan("");
    setRecoleccion("");
    setValor("");
    setInsumos("");
    setKilos("");
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setUpdatedData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      const allFieldsFilled = Object.values(newData).every(
        (val) => String(val || "").trim() !== ""
      );
      setIsUpdating(allFieldsFilled);

      return newData;
    });
  };

  const enableEditing = (contract) => {
    setEditingContract(contract.no_contrato);
    console.log(contract.plan);

    setUpdatedData({
      newNumberContract: contract.no_contrato,
      state_contract:
        contract.state_contract.includes("x") ||
        contract.state_contract.includes("X")
          ? null
          : contract.state_contract,
      ruta: contract.ruta,
      tipo_cliente:
        contract.tipo_cliente.includes("x") ||
        contract.tipo_cliente.includes("X")
          ? null
          : contract.tipo_cliente,
      fecha_afiliacion: contract.fecha_afiliacion
        ? format(contract.fecha_afiliacion, "yyyy-MM-dd")
        : null,
      tipo_establecimiento: contract.tipo_establecimiento,
      nombre_establecimiento: contract.nombre_establecimiento,
      representante: contract.representante,
      nit: contract.nit,
      barrio: contract.barrio,
      direccion: contract.direccion,
      telefono: contract.telefono,
      correo: contract.correo,
      plan:
        contract.plan.includes("x") || contract.plan.includes("X")
          ? null
          : contract.plan,
      recoleccion: contract.recoleccion,
      valor: contract.valor,
      insumos: contract.insumos,
      kilos: contract.kilos,
    });
    setIsUpdating(true);
  };

  const updateContract = () => {
    if (!isUpdating) return;

    const formattedData = {
      ...updatedData,
    };

    fetch(`${API_URL}/update-contract/${editingContract}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    })
      .then((response) => response.json())
      .then(() => {
        openModalSuccess("update");
        getContracts();
        setEditingContract(null);
        setIsUpdating(false);
      })
      .catch((error) =>
        console.error("Error al actualizar el contrato:", error)
      );
  };

  const deleteContract = (noContract) => {
    fetch(`${API_URL}/contract-delete/${noContract}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          openModalSuccess("delete");
          getContracts();
        } else {
          alert("Error al eliminar el empleado.");
        }
      })
      .catch((error) => console.error("Error al eliminar el contrato:", error));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value === "") {
      setListContractsFiltered(listContracts);
      return;
    }

    const filteredContracts = listContracts.filter((contract) =>
      contract[filterField]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    );

    setListContractsFiltered(filteredContracts);
  };

  const getContracts = () => {
    setIsLoading(true);
    fetch(`${API_URL}/contracts`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setIsLoading(false);
          setListContracts(result.result);
          setListContractsFiltered(result.result);
          getNextContractNumber(result.result);
        } else {
          console.log("No se pudo consultar los empleados");
        }
      });
  };

  const getPlans = () => {
    fetch(`${API_URL}/plans`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListPlans(result.result);
        } else {
          console.log("No se pudo consultar los planes");
        }
      });
  };

  const searchPlan = (plan, action) => {
    fetch(`${API_URL}/plans/${plan}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result && result?.plan) {
          if (action === "create") {
            setValor(result.plan.precio_plan);
            setInsumos(result.plan.insumos);
            setKilos(result.plan.kilos);
          }
          if (action === "update") {
            setUpdatedData((prev) => {
              const newData = {
                ...prev,
                valor: result.plan.precio_plan,
                insumos: result.plan.insumos,
                kilos: result.plan.kilos,
              };
              return newData;
            });
          }
        } else {
          console.log("No se encontro el plan");
        }
      })
      .catch(() => {
        console.log("Error de servidor");
      });
  };

  const addEmployee = () => {
    const data = {
      noContrato,
      stateContract,
      ruta,
      tipoCliente,
      currentDate,
      tipoEstablecimiento,
      nombreEstablecimiento,
      representanteLegal,
      nit,
      barrio,
      direccion,
      telefono,
      correo,
      plan,
      recoleccion,
      valor,
      insumos,
      kilos,
    };

    if (
      !ruta ||
      !tipoCliente ||
      !tipoEstablecimiento ||
      !nombreEstablecimiento ||
      !representanteLegal ||
      !nit ||
      !direccion ||
      !correo ||
      !plan ||
      !recoleccion
    ) {
      setEmptyData(true);
      setTimeout(() => {
        setEmptyData(false);
      }, 3000);
      return;
    }
    fetch(`${API_URL}/create-contract`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          openModalSuccess("create");
          cleanFormContracts();
          getContracts();
        } else {
          alert("No se pudo registrar el empleado");
        }
      })
      .catch(() => {
        console.log("ERROR CACTH");
      });
  };

  return (
    <div className="employees-container">
      {/* Tabla */}
      <div className="table-container">
        <h2>Consulta de contratos</h2>
        <div className="filter-container">
          <select
            value={filterField}
            onChange={(e) => {
              setFilterField(e.target.value);
            }}
          >
            <option value="no_contrato"># Contrato</option>
            <option value="nit">NIT</option>
            <option value="nombre_establecimiento">
              Nombre del establecimiento
            </option>
          </select>
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        <table>
          <thead>
            <tr>
              <th># Contrato</th>
              <th>Estado del contrato</th>
              <th>Ruta</th>
              <th>Tipo de cliente</th>
              <th>Fecha de afiliación</th>
              <th>Tipo de establecimiento</th>
              <th>Nombre del establecimiento</th>
              <th>Representante Legal</th>
              <th>NIT</th>
              <th>Barrio</th>
              <th>Dirección</th>
              <th>Teléfono</th>
              <th>Correo</th>
              <th>Plan</th>
              <th>Recolecciòn</th>
              <th>Valor</th>
              <th>Insumos</th>
              <th>Kilos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.map((contract) => {
              return (
                <tr key={contract.no_contrato}>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        className="w-table-inputs"
                        type="number"
                        value={updatedData.newNumberContract}
                        onChange={(e) =>
                          handleInputChange(e, "newNumberContract")
                        }
                      />
                    ) : (
                      contract.no_contrato
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <select
                        onChange={(e) => handleInputChange(e, "state_contract")}
                        value={updatedData.state_contract || ""}
                        className="w-table-inputs"
                      >
                        <option value="" disabled selected>
                          Seleccione el estado
                        </option>
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="CANCELADO">CANCELADO</option>
                      </select>
                    ) : (
                      contract.state_contract
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.ruta}
                        onChange={(e) => handleInputChange(e, "ruta")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.ruta
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <select
                        onChange={(e) => handleInputChange(e, "tipo_cliente")}
                        value={updatedData.tipo_cliente || ""}
                        className="w-table-inputs"
                      >
                        <option value="" disabled>
                          Seleccione el tipo de cliente
                        </option>
                        <option value="empresarial">Empresarial</option>
                        <option value="natural">Natural</option>
                      </select>
                    ) : (
                      contract.tipo_cliente
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="date"
                        value={
                          updatedData.fecha_afiliacion
                            ? updatedData.fecha_afiliacion
                            : format(new Date(), "yyyy-MM-dd")
                        }
                        onChange={(e) =>
                          handleInputChange(e, "fecha_afiliacion")
                        }
                        className="w-table-inputs"
                      />
                    ) : (
                      contract?.fecha_afiliacion?.split("T")[0] ||
                      "No hay registro de fecha de afiliación"
                    )}
                  </td>

                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.tipo_establecimiento}
                        onChange={(e) =>
                          handleInputChange(e, "tipo_establecimiento")
                        }
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.tipo_establecimiento
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.nombre_establecimiento}
                        onChange={(e) =>
                          handleInputChange(e, "nombre_establecimiento")
                        }
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.nombre_establecimiento
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.representante}
                        onChange={(e) => handleInputChange(e, "representante")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.representante
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.nit}
                        onChange={(e) => handleInputChange(e, "nit")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.nit
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.barrio}
                        onChange={(e) => handleInputChange(e, "barrio")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.barrio
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.direccion}
                        onChange={(e) => handleInputChange(e, "direccion")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.direccion
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.telefono}
                        onChange={(e) => handleInputChange(e, "telefono")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.telefono
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.correo}
                        onChange={(e) => handleInputChange(e, "correo")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.correo
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <select
                        onChange={(e) => {
                          handleInputChange(e, "plan");
                          searchPlan(e.target.value, "update");
                        }}
                        value={updatedData.plan}
                        className="w-table-inputs"
                      >
                        <option value="" disabled selected>
                          Seleccione un plan
                        </option>
                        {listPlans.map((value) => (
                          <option key={value.id} value={value.plan}>
                            {value.plan}
                          </option>
                        ))}
                      </select>
                    ) : (
                      contract.plan
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        type="text"
                        value={updatedData.recoleccion}
                        onChange={(e) => handleInputChange(e, "recoleccion")}
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.recoleccion
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        value={updatedData.valor}
                        disabled
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.valor
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        value={updatedData.insumos}
                        disabled
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.insumos
                    )}
                  </td>
                  <td>
                    {editingContract === contract.no_contrato ? (
                      <input
                        value={updatedData.kilos}
                        disabled
                        className="w-table-inputs"
                      />
                    ) : (
                      contract.kilos
                    )}
                  </td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={() => enableEditing(contract)}
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteContract(contract.no_contrato)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="pagination">
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            ⏮ Primera
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ◀ Anterior
          </button>
          <span>
            Página {currentPage} de {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Siguiente ▶
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            Última ⏭
          </button>
        </div>
      </div>
      {isUpdating && (
        <button
          className="btn-add-controle-panel"
          onClick={updateContract}
          disabled={!isUpdating}
        >
          Actualizar
        </button>
      )}
      {/* Formulario */}
      <div className="form-container mb-5">
        <h2>Registro de contratos</h2>
        <div className="form-group">
          <label htmlFor="no_contrato">Número de contrato*</label>
          <input
            type="number"
            id="no_contrato"
            placeholder="Escribe el número de contrato"
            value={noContrato}
            disabled
          />
        </div>
        <div className="form-group">
          <label htmlFor="ruta">Ruta*</label>
          <input
            type="text"
            id="ruta"
            placeholder="Escribe la ruta"
            onChange={(e) => {
              setRuta(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="tipo_cliente">Tipo de cliente*</label>
          <select
            id="tipo_cliente"
            onChange={(e) => {
              setTipoCliente(e.target.value);
            }}
            value={tipoCliente}
          >
            <option value="" disabled selected>
              Selecciona un tipo de cliente
            </option>
            <option value="empresarial">Empresarial</option>
            <option value="natural">Natural</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="fecha_afiliacion">Fecha de afiliación*</label>
          <input
            type="text"
            id="fecha_afiliacion"
            value={currentDate}
            disabled
          />
        </div>
        <div className="form-group">
          <label htmlFor="tipo_establecimiento">Tipo de establecimiento*</label>
          <input
            type="text"
            id="tipo_establecimiento"
            placeholder="Escribe el tipo de establecimiento"
            onChange={(e) => {
              setTipoEstablecimiento(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="nombre_establecimiento">
            Nombre del establecimiento*
          </label>
          <input
            type="text"
            id="nombre_establecimiento"
            placeholder="Escribe el tipo de establecimiento"
            onChange={(e) => {
              setNombreEstablecimiento(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="representante">Representante legal*</label>
          <input
            type="text"
            id="representante"
            placeholder="Escribe el representante legal"
            onChange={(e) => {
              setRepresentanteLegal(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="nit">NIT*</label>
          <input
            type="text"
            id="nit"
            placeholder="Escribe el NIT"
            onChange={(e) => {
              setNit(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="barrio">Barrio</label>
          <input
            type="text"
            id="barrio"
            placeholder="Escribe el barrio"
            onChange={(e) => {
              setBarrio(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="direccion">Dirección*</label>
          <input
            type="text"
            id="direccion"
            placeholder="Escribe la dirección"
            onChange={(e) => {
              setDireccion(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="telefono">Telefono</label>
          <input
            type="text"
            id="telefono"
            placeholder="Escribe el telefono de contacto"
            onChange={(e) => {
              setTelefono(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="correo">Correo*</label>
          <input
            type="text"
            id="correo"
            placeholder="Escribe el correo"
            onChange={(e) => {
              setCorreo(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="plan">Plan*</label>
          <select
            id="plan"
            onChange={(e) => {
              setPlan(e.target.value);
              searchPlan(e.target.value, "create");
            }}
            value={plan}
          >
            <option value="" disabled selected>
              Selecciona un plan
            </option>
            {listPlans.map((value) => (
              <option key={value.id} value={value.plan}>
                {value.plan}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="recoleccion">Recolección*</label>
          <input
            type="text"
            id="recoleccion"
            onChange={(e) => {
              setRecoleccion(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="valor">Precio*</label>
          <input type="text" id="valor" value={valor} disabled />
        </div>
        <div className="form-group">
          <label htmlFor="insumos">Insumos*</label>
          <input type="text" id="insumos" value={insumos} disabled />
        </div>
        <div className="form-group">
          <label htmlFor="kilos">Kilos*</label>
          <input type="text" id="kilos" value={kilos} disabled />
        </div>
        <div className="add-container">
          <button className="btn-add-employee" onClick={addEmployee}>
            Registrar
          </button>
        </div>
      </div>
      {isModalOpen && (
        <div className="modal-success">
          <div className="modal-content">
            <FaCheckCircle size={100} color="green" className="modal-icon" />
            <h1>{messageModal}</h1>
          </div>
        </div>
      )}
      {isLoading && (
        <div className="modal-loading">
          <div className="spinner"></div>
          <p>Cargando contratos...</p>
        </div>
      )}
      {emptyData && (
        <div className="modal-success">
          <div className="modal-content">
            <FaTimesCircle size={100} color="red" className="modal-icon" />
            <h1>Por favor llenar todos los campos obligatorios(*)</h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contracts;
